<div class="app-login-broker container-fluid animated" [ngClass]="{
  'multi-broker': isMultiBroker || isRanking,
  'login-broker' : !isMultiBroker && !whitelabel.system.isTransition.active && !showDoubleAutheticationCode,
  'transition': whitelabel.system.isTransition.active || (showDoubleAutheticationCode && model.type === 'password') }">
  <ng-container *ngIf="!whitelabel.system.isTransition.active; else elseTemplateTransition">
    <div [ngSwitch]="whitelabel.system.login_type">
      <div *ngSwitchCase="loginType.LoginS">
        <ng-container *ngTemplateOutlet="templateMultiBroker"></ng-container>
      </div>
      <div *ngSwitchCase="loginType.LoginA">
        <ng-container *ngTemplateOutlet="templateWhitelabel"></ng-container>
      </div>
      <div *ngSwitchCase="loginType.LoginO">
        <ng-container *ngTemplateOutlet="templateWhitelabel"></ng-container>
      </div>
    </div>
  </ng-container>
  <ng-template #elseTemplateTransition>
    <ng-container *ngTemplateOutlet="templateTransition"></ng-container>
  </ng-template>
</div>

<!-- TEMPLATE: Whitelabel -->
<ng-template #templateWhitelabel>
  <div class="row justify-content-center align-items-center max-vh" *ngIf="!showDoubleAutheticationCode">
    <div class="col-12 col-md-6 pad-form">
      <div class="row max-row">
        <div class="col-12 header">
          <ng-container *ngTemplateOutlet="logoTemplate"></ng-container>
        </div>
        <div class="col-12 box-form">
          <ng-container *ngTemplateOutlet="titleSubTitleTemplate"></ng-container>
          <div class="col-12 p-0">
            <ng-container *ngTemplateOutlet="formTemplate"></ng-container>
          </div>
        </div>
      </div>
    </div>
    <ng-container *ngTemplateOutlet="infoServiceTemplate"></ng-container>
    <!-- <div class="col-12 col-md-6"> -->
    <ng-container *ngTemplateOutlet="carouselTemplate"></ng-container>
    <!-- </div> -->
  </div>
  <div class="row justify-content-center max-vh transition" *ngIf="showDoubleAutheticationCode">
    <ng-container *ngTemplateOutlet="headerTransition"></ng-container>
    <div class="col-12" *ngIf="showDoubleAutheticationCode">
      <ng-container *ngTemplateOutlet="doubleAutheticationTemplate"></ng-container>
    </div>
  </div>
</ng-template>

<!-- TEMPLATE: Multi Broker -->
<ng-template #templateMultiBroker>
  <div class="row justify-content-center">
    <!-- header -->
    <div class="col-12 header">
      <div class="row">
        <div class="col-12 col-md-6">
          <ng-container *ngTemplateOutlet="logoTemplate"></ng-container>
        </div>
        <div class="col-12 col-md-6 action">
          <span>Ainda não tem uma conta?</span>
          <button mat-stroked-button id="btn-login-create-account" color="primary01" (click)="createAccount()">Criar
            Conta</button>
        </div>
      </div>
    </div>
    <!-- formulario -->
    <div class=" col-12 box-form">
      <ng-container *ngTemplateOutlet="titleSubTitleTemplate"></ng-container>
      <div class="col-12">
        <ng-container *ngTemplateOutlet="formTemplate"></ng-container>
      </div>
    </div>
    <div class="col-12 help" *ngIf="whitelabel?.contact?.supportPhone?.phoneNumber && isMultiBroker">
      <span class="message">Em caso de dúvidas, entre em contato
        <span *ngIf="whitelabel?.contact?.supportPhone?.isWhatsApp"> no WhatsApp</span>
        <span *ngIf="!whitelabel?.contact?.supportPhone?.isWhatsApp"> conosco</span>
      </span>

      <ng-container *ngIf="whitelabel && whitelabel.contact.supportPhone && whitelabel.contact.supportPhone.isWhatsApp; else elseTemplate">
        <a [attr.href]="whatsAppNumber" target="_blank" id="span-open-whatsapp" class="phone" >
          {{ whitelabel?.contact?.supportPhone?.phoneNumber }}</a>
      </ng-container>
      <ng-template #elseTemplate>
        <span id="span-open-whatsapp" class="phone" >
          {{ whitelabel?.contact?.supportPhone?.phoneNumber }}</span>
      </ng-template>


    </div>
  </div>
</ng-template>

<!-- TEMPLATE: Transition -->
<ng-template #templateTransition>
  <div class="row justify-content-center max-vh transition">
    <!-- <ng-container *ngTemplateOutlet="headerTransition"></ng-container> -->
    <div class="col-12 content-transition">
      <div class="row" *ngIf="!showDoubleAutheticationCode">
        <!-- <div class="col-12 icon">
          <mat-icon svgIcon="login-transition"></mat-icon>
        </div>
        <div class="col-12 title">{{ whitelabel?.system?.isTransition?.title }}</div>
        <div class="col-12 sub-title">{{ whitelabel?.system?.isTransition?.subTitle }}</div> -->
        <div class="col-12">
          <div class="spinner spinner-login">
            <app-spinner-loading></app-spinner-loading>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12" *ngIf="showDoubleAutheticationCode">
      <ng-container *ngTemplateOutlet="doubleAutheticationTemplate"></ng-container>
    </div>
  </div>
</ng-template>

<ng-template #headerTransition>
  <div class="col-12 header" [ngClass]="{'success': showMessageSSOsuccess, 'error': showMessageSSOerror}">
    <div class="row message">
      <div class="col-12 logo" *ngIf="!showMessageSSOsuccess && !showMessageSSOerror">
        <img class="user-picture" src="{{ logoTransition }}">
      </div>
      <div class="col-12" *ngIf="showMessageSSOsuccess || showMessageSSOerror">
        <div class="row">
          <div class="col-1">
            <mat-icon svgIcon="{{iconMessageService}}"></mat-icon>
          </div>
          <div class="col-11">
            <div class="row">
              <div class="col-12 title">{{ messageServiceTitle }}</div>
              <div class="col-12">{{ messageServiceDetails }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>


<ng-template #logoTemplate>
  <div class="logo" [ngClass]="{'cursor': whitelabel?.contact?.urlHbWhitelabel }" (click)="openHb()"></div>
</ng-template>

<ng-template #titleSubTitleTemplate>
  <div class="col-12 form-title">
    {{ isMultiBroker ? titleMultiBroker :
    !isMultiBroker && whitelabel?.system?.cod !== 10 && !showDoubleAutheticationQuestion && !showExpiredPassword
    ? title :
    !isMultiBroker && whitelabel?.system?.cod !== 10 && showDoubleAutheticationQuestion && !showExpiredPassword
    ? titleDoubleAuthentication : !isMultiBroker && whitelabel?.system?.cod !== 10 && !showDoubleAutheticationQuestion
    && showExpiredPassword ? titleExpiredPassword : titleRanking }}
  </div>
  <div class="col-12 form-subTitile">
    {{ isMultiBroker && !showExpiredPassword ? subTitleMultiBroker :
    whitelabel?.system?.cod !== 10 && !showDoubleAutheticationQuestion && !showExpiredPassword ? subTitle :
    whitelabel?.system?.cod === 10 && !showDoubleAutheticationQuestion && !showExpiredPassword ? subTitleRanking :
    !isMultiBroker && !showDoubleAutheticationQuestion && showExpiredPassword ? subTitleExpiredPassword :
    questionActive.question }}
  </div>
</ng-template>

<ng-template #carouselTemplate>
  <div class="col-12 col-md-6 r-content carousel" id="carouselExampleIndicators"
    [ngClass]="{'slideInRight': !isUserLogged }" data-ride="carousel"
    *ngIf="!isMultiBroker && whitelabel?.system?.cod !== 10">
    <ol class="carousel-indicators">
      <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
      <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
      <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
    </ol>
    <div class="carousel-inner h-100">
      <div class="carousel-item active h-100">
        <div class="d-block w-100 h-100 slide1" alt="First slide"></div>
      </div>
      <div class="carousel-item h-100">
        <div class="d-block w-100 h-100 slide2" alt="Second slide"></div>
      </div>
      <div class="carousel-item h-100">
        <div class="d-block w-100 h-100 slide3" alt="Third slide"></div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #infoServiceTemplate>
  <div class="phone-broker" [ngClass]="whitelabel?.contact?.supportPhone?.infoService ? 'phone-info-service' : ''"
    *ngIf="whitelabel?.login?.showHelpLogin">
    <div class="row">
      <div class="col-1 phone-icon" *ngIf="whitelabel?.contact?.supportPhone?.isWhatsApp">
        <mat-icon svgIcon="phone" class="icon_coin"></mat-icon>
      </div>
      <div class="col-10">
        <div class="row">
          <div *ngIf="!whitelabel?.contact?.supportPhone?.infoService" class="col-12">
            {{whitelabel?.contact?.supportPhone?.phoneTitle}}
          </div>
          <div *ngIf="!whitelabel?.contact?.supportPhone?.infoService" class="col-12">
            {{whitelabel?.contact?.supportPhone?.phoneNumber}}
          </div>
          <div *ngIf="whitelabel?.contact?.supportPhone?.infoService" class="col-12">
            <span class="title">{{whitelabel?.contact?.supportPhone?.phoneTitle}}</span>
            <span>{{whitelabel?.contact?.supportPhone?.phoneNumber}}</span>
          </div>
          <div *ngIf="whitelabel?.contact?.supportPhone?.infoService" class="col-12">
            {{whitelabel?.contact?.supportPhone?.infoService}}
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #doubleAutheticationTemplate>
  <div class="row double-auth">
    <div class="col-12 title fz-26">Dupla autenticação</div>
    <div class="col-12 sub-title">Enviamos um {{ sendCodeSms ? 'SMS' : 'E-mail' }} com um código para
      confirmar sua identidade.</div>
    <div class="col-12 sub-title cod">Código</div>
    <div class="col-12 form-double">
      <div class="row">
        <form name="doubleAuthForm" (ngSubmit)="doubleAuthForm.form.valid" #doubleAuthForm="ngForm" novalidate>
          <div class="col-2">
            <mat-form-field class="input-double-auth"
              [ngClass]="{'invalid': numberAuthOne.touched && numberAuthOne.invalid }">
              <input tabindex="1" id="input-1" matInput autocomplete="numberAuthOne" name="numberAuthOne"
                [(ngModel)]="model.numberAuthOne" #numberAuthOne="ngModel" minlength="1" maxlength="1"
                (keypress)="validChar($event)" (keydown)="keyPressed($event)" (keyup)="keyUpped()" required>
            </mat-form-field>
          </div>
          <div class="col-2">
            <mat-form-field class="input-double-auth"
              [ngClass]="{'invalid': numberAuthTwo.touched && numberAuthTwo.invalid }">
              <input tabindex="2" id="input-2" matInput autocomplete="numberAuthTwo" name="numberAuthTwo"
                [(ngModel)]="model.numberAuthTwo" #numberAuthTwo="ngModel" minlength="1" maxlength="1"
                (keypress)="validChar($event)" (keydown)="keyPressed($event)" (keyup)="keyUpped()" required>
            </mat-form-field>
          </div>
          <div class="col-2">
            <mat-form-field class="input-double-auth"
              [ngClass]="{'invalid': numberAuthThree.touched && numberAuthThree.invalid }">
              <input tabindex="3" id="input-3" matInput autocomplete="numberAuthThree" name="numberAuthThree"
                [(ngModel)]="model.numberAuthThree" #numberAuthThree="ngModel" minlength="1" maxlength="1"
                (keypress)="validChar($event)" (keydown)="keyPressed($event)" (keyup)="keyUpped()" required>
            </mat-form-field>
          </div>
          <div class="col-2">
            <mat-form-field class="input-double-auth"
              [ngClass]="{'invalid': numberAuthFour.touched && numberAuthFour.invalid }">
              <input tabindex="4" id="input-4" matInput autocomplete="numberAuthFour" name="numberAuthFour"
                [(ngModel)]="model.numberAuthFour" #numberAuthFour="ngModel" minlength="1" maxlength="1"
                (keypress)="validChar($event)" (keydown)="keyPressed($event)" (keyup)="keyUpped()" required>
            </mat-form-field>
          </div>
          <div class="col-2">
            <mat-form-field class="input-double-auth"
              [ngClass]="{'invalid': numberAuthFive.touched && numberAuthFive.invalid }">
              <input tabindex="5" id="input-5" matInput autocomplete="numberAuthFive" name="numberAuthFive"
                [(ngModel)]="model.numberAuthFive" #numberAuthFive="ngModel" minlength="1" maxlength="1"
                (keypress)="validChar($event)" (keydown)="keyPressed($event)" (keyup)="keyUpped()" required>
            </mat-form-field>
          </div>
          <div class="col-2">
            <mat-form-field class="input-double-auth"
              [ngClass]="{'invalid': numberAuthSix.touched && numberAuthSix.invalid }">
              <input tabindex="6" id="input-6" matInput autocomplete="numberAuthSix" name="numberAuthSix"
                [(ngModel)]="model.numberAuthSix" #numberAuthSix="ngModel" minlength="1" maxlength="1"
                (keypress)="validChar($event)" (keydown)="keyPressed($event)" (keyup)="keyUpped()" required>
            </mat-form-field>
          </div>
        </form>
      </div>
    </div>
    <div class="col-12">
      <div class="row">
        <div class="col-6 sub-title resend left cursor" *ngIf="showResendCode" (click)="resendSmsOrEmail('email')">
          Reenviar por e-mail</div>
        <div class="col-6 sub-title resend right cursor" *ngIf="showResendCode" (click)="resendSmsOrEmail('sms')">
          Reenviar por SMS</div>
      </div>
    </div>
    <div class="col-12">
      <div class="row">
        <div class="col-6 sub-title bold cursor" (click)="redirecLogout()">Cancelar</div>
        <div class="col-6 btn-broker" [ngClass]="{'m-btn': showDoubleAutheticationCode}">
          <button [ngClass]="{ 'fadeIn': !loadingTransitionAdpterSSO, 'fadeOut': loadingTransitionAdpterSSO, 'error': doubleAuthForm.form.invalid && doubleAuthForm.touched && numberAuthOne.invalid,
          'success': !loadingTransitionAdpterSSO && isUserLogged }" mat-raised-button color="primary02"
            class="animated" type="submit" [disabled]="isRequest" (click)="validDoubleSSO()"
            [disabled]="loadingTransitionAdpterSSO">
            <span *ngIf="!loadingTransitionAdpterSSO">Confirmar</span>
            <mat-spinner *ngIf="loadingTransitionAdpterSSO" class="spinner" diameter="38" color="primary02">
            </mat-spinner>
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #formTemplate>
  <form name="form" (ngSubmit)="loginForm.form.valid" #loginForm="ngForm" novalidate>
    <div id="snack-bar-msg" class="col-12 snack-bar-msg snack-bar-msg-top">
      <div #snackBar></div>
    </div>
    <div class="col-12 form-div">
      <div class="row multibroker-form">
        <div class="col-12 mt-1">
          <mat-form-field appearance="{{ isMultiBroker ? 'outline' : ''}}">
            <mat-label *ngIf="isMultiBroker">{{ messageInputLogin?.inputUsername }}</mat-label>
            <input matInput matTooltipPosition="above" id="input-login-username"
              matTooltip="{{ !showDoubleAutheticationQuestion ? ( showExpiredPassword ? 'Nova Senha' : messageInputLogin?.tooltipUsername) : '' }}"
              type="{{ !showDoubleAutheticationQuestion && !showPasswordConfirm ? 'text' : 'password'}}"
              (keyup)="!showExpiredPassword ? resetValidity($event) : validatorPassword2(model.dinamicInput)"
              placeholder="{{ !showDoubleAutheticationQuestion && !showExpiredPassword ? messageInputLogin?.inputUsername : !showDoubleAutheticationQuestion && showExpiredPassword ? 'Nova Senha' : 'Resposta'}}"
              autocomplete="{{ !showDoubleAutheticationQuestion && !showExpiredPassword ? 'username' : !showDoubleAutheticationQuestion && showExpiredPassword ? 'newPassword' : 'questionResp'}}"
              name="{{ !showDoubleAutheticationQuestion && !showExpiredPassword ? 'username' : !showDoubleAutheticationQuestion && showExpiredPassword ? 'newPassword' : 'questionResp'}}"
              [(ngModel)]="model.dinamicInput" #username="ngModel" minlength="2" maxlength="255"
              (keypress)="validChar($event)">
            <span *ngIf="showExpiredPassword && model.dinamicInput && model.dinamicInput != ''"
              (click)="togglePasswordConfirm()" class="showHideSuffix" matSuffix>
              {{showPasswordConfirm ? 'ocultar': 'mostrar'}}</span>
            <mat-icon *ngIf="!showExpiredPassword && username.touched && username.valid" matSuffix class="valid">
              done</mat-icon>
            <mat-icon *ngIf="!showExpiredPassword && username.touched && username.invalid" matSuffix class="invalid">
              clear
            </mat-icon>
            <mat-error
              *ngIf="(username.touched || username.invalid) && (username.value == '' || username.value == null || username.value == undefined)">
              Campo obrigatório</mat-error>
          </mat-form-field>
        </div>
        <div class="col-12 m-input" [hidden]="showDoubleAutheticationQuestion">
          <mat-form-field appearance="{{ isMultiBroker ? 'outline' : ''}}">
            <mat-label *ngIf="isMultiBroker">{{ messageInputLogin?.inputPassword }}</mat-label>
            <input id="input-login-password"
              (keyup)="!showExpiredPassword ? resetValidity($event) : validatorPassword(model.password)"
              [type]="showpassword ? 'text' : 'password'" matInput
              placeholder="{{ !isMultiBroker && !showExpiredPassword ? messageInputLogin?.inputPassword : !isMultiBroker && showExpiredPassword ? 'Confirmar nova senha' : ''}}"
              autocomplete="new-password" name="password" [(ngModel)]="model.password" #password="ngModel" minlength="0"
              maxlength="255" (keypress)="validChar($event)" (paste)="validatePastedString($event)">
            <span *ngIf="model.password && model.password != ''" (click)="togglePassword()" class="showHideSuffix"
              matSuffix>{{showpassword ? 'ocultar': 'mostrar'}}</span>
            <mat-error
              *ngIf="(password.value == '' || password.value == null || password.value == undefined) && (password.touched || password.invalid)">
              Campo obrigatório</mat-error>
          </mat-form-field>
        </div>
        <div class="col-12 forgot-password"
          *ngIf="whitelabel?.password && !showDoubleAutheticationQuestion && !showExpiredPassword">
          <span id="link-login-forgot-password" (click)="forgotPassword()">
            {{ messageInputLogin.inputForgotPassword }}</span>
        </div>
        <div class="col-12 msg-error-one" *ngIf="showExpiredPassword && showPasswordInvalid">
          <span class="message-error">{{ errorMsg01 }}</span>
        </div>
        <div class="col-12 complexy-password" *ngIf="showExpiredPassword">
          <div class="row">
            <div class="col-12 bold">Sugestão de senha:</div>
            <div class="col-6 t-left">
              <div>
                <mat-icon *ngIf="passwordComplexyLength" svgIcon="success-password"></mat-icon>
                <mat-icon *ngIf="!passwordComplexyLength" svgIcon="success-password-disable"></mat-icon>
                <span [ngClass]="{'valid': passwordComplexyLength }">Pelo menos 8 caracteres</span>
              </div>
              <div>
                <mat-icon *ngIf="passwordComplexyNumber" svgIcon="success-password"></mat-icon>
                <mat-icon *ngIf="!passwordComplexyNumber" svgIcon="success-password-disable"></mat-icon>
                <span [ngClass]="{'valid': passwordComplexyNumber }">Um número de (0-9)</span>
              </div>
              <div>
                <mat-icon *ngIf="passwordComplexySpecial" svgIcon="success-password"></mat-icon>
                <mat-icon *ngIf="!passwordComplexySpecial" svgIcon="success-password-disable"></mat-icon>
                <span [ngClass]="{'valid': passwordComplexySpecial }">Um caractere especial (@#*)</span>
              </div>
            </div>
            <div class="col-6 p-0 t-left">
              <div>
                <mat-icon *ngIf="passwordComplexyLetterDown" svgIcon="success-password"></mat-icon>
                <mat-icon *ngIf="!passwordComplexyLetterDown" svgIcon="success-password-disable"></mat-icon>
                <span [ngClass]="{'valid': passwordComplexyLetterDown }">Uma letra minúscula (a-z)</span>
              </div>
              <div>
                <mat-icon *ngIf="passwordComplexyLetterUp" svgIcon="success-password"></mat-icon>
                <mat-icon *ngIf="!passwordComplexyLetterUp" svgIcon="success-password-disable"></mat-icon>
                <span [ngClass]="{'valid': passwordComplexyLetterUp }">Use letras maiúscula (A-Z)</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 broker-list"
          *ngIf="isMultiBroker && !showDoubleAutheticationQuestion && multiBrokerloginType === 3">
          <mat-form-field appearance="outline">
            <mat-label>
              {{ loading && brokeragePartners?.length <=0 ? 'Carregando...' : 'Selecione uma corretora' }} </mat-label>
                <mat-select panelClass="custom-broker-select" [(ngModel)]="multiBrokerSelected"
                  (selectionChange)="setConfigMultiBroker()" name="multiBrokerSelected"
                  [disabled]="brokeragePartners?.length <= 0 || !model.password || !model.dinamicInput"
                  id="select-broker">
                  <mat-option class="custom-register-option" *ngFor="let item of brokeragePartners" [value]="item"
                    id="select-broker-{{item.usersBrokerName}}">
                    <img class="imgBroker" src="{{ item.usersBrokerImamge }}"
                      onError="this.src='./assets/images/symbols/INDISPONIVEL.PNG';">
                    {{item.usersBrokerViewName}}
                  </mat-option>
                </mat-select>
          </mat-form-field>
        </div>
        <div class="col-12 btn-broker" [ngClass]="{'m-btn': showDoubleAutheticationQuestion}">
          <div *ngIf="loading && !isMultiBroker" class="spinner-login">
            <mat-spinner class="spinner" diameter="38" color="primary-broker"></mat-spinner>
          </div>
          <button *ngIf="!isMultiBroker" [ngClass]="{ 'fadeIn': !loading, 'fadeOut': loading, 'error': loginForm.form.invalid && loginForm.touched && username.invalid && password.invalid,
        'success': !loading && isUserLogged }" mat-raised-button color="primary02" class="animated" type="submit"
            [disabled]="isRequest" id="btn-login" (click)="sendLogin()">
            <span *ngIf="!loading">{{ !showDoubleAutheticationQuestion && !showExpiredPassword ? 'Entrar' :
              !showDoubleAutheticationQuestion && showExpiredPassword ? 'Alterar' : 'Enviar' }}</span>
          </button>
          <button *ngIf="isMultiBroker && !showDoubleAutheticationQuestion" [ngClass]="{ 'fadeIn': !loading, 'fadeOut': loading, 'error': loginForm.form.invalid && loginForm.touched && username.invalid && password.invalid,
        'success': !loading && isUserLogged }" mat-stroked-button color="primary02" class="animated" type="submit"
            id="btn-login" type="submit" [disabled]="isRequest" (click)="sendLogin()">
            <span *ngIf="!loading">{{ 'Entrar' }}</span>
            <mat-spinner *ngIf="loading" class="spinner" diameter="38" color="primary-broker"></mat-spinner>
          </button>
          <div id="snack-bar-msg" class="snack-bar-msg">
            <div #snackBar></div>
          </div>
        </div>
        <div class="col-12 new-account" *ngIf="whitelabel?.login?.showBtnNewAccount || isRanking">
          Ainda não tem uma conta? <a id="link-login-create-Account" (click)="createAccount()">Crie sua conta</a>
        </div>
        <div class="col-12 new-account" *ngIf="showUrlStore">
          Acessar <a id="link-login-create-Account" (click)="openStore()">Minha Conta</a>
          <mat-icon class="icon store" svgIcon="question" matTooltipPosition="above" matTooltip="{{messageStore}}">
          </mat-icon>
        </div>
        <div class="col-12 cvm-message" *ngIf="whitelabel?.login?.showInfoLogin">
          <div class="row">
            <div class="col-12 message"
              *ngIf="whitelabel?.login?.textFristInfo && whitelabel?.login?.showPolicyCvmAndBrowser">
              {{ whitelabel?.login?.textFristInfo }}
            </div>
            <div class="col-12 message" *ngIf="whitelabel?.login?.textSecondInfo">
              <span>{{whitelabel?.login?.textSecondInfo}}</span>
              <a *ngIf="whitelabel?.login?.linkInfo" href="{{whitelabel?.login?.linkInfo}}" target="_blank"> {{
                whitelabel?.login?.linkInfo }} </a>
            </div>
            <div class="col-12 logo-cvm" *ngIf="whitelabel?.login?.showPolicyCvmAndBrowser">
              <img src="./../../../assets/images/png/logo_cvm.png" (click)="openLinkCvm()" />
              <img src="./../../../assets/images/png/BM&FBovespa.png" (click)="openLinkBmfBovespa()" />
            </div>
            <div class="col-12 browser" *ngIf="whitelabel?.login?.showPolicyCvmAndBrowser">Navegadores recomendados:
              <mat-icon class="icon" svgIcon="icon_chrome" matTooltipPosition="above" matTooltip="Google Chrome">
              </mat-icon>
              <mat-icon class="icon" svgIcon="icon_firefox" matTooltipPosition="above" matTooltip="Firefox">
              </mat-icon>
              <mat-icon class="icon" svgIcon="icon_opera" matTooltipPosition="above" matTooltip="Opera"></mat-icon>
              <mat-icon class="icon" svgIcon="icon_safari" matTooltipPosition="above" matTooltip="Safari">
              </mat-icon>
            </div>
          </div>
        </div>
        <div class="col-12 informative-text" [ngClass]="{'cursor': whitelabel?.contact?.urlHbWhitelabel }"
          *ngIf="whitelabel?.login?.showInfoTextLogin?.active">
          <li *ngFor="let item of whitelabel?.login?.showInfoTextLogin?.text">{{ item.text }}</li>
        </div>
      </div>
    </div>
  </form>
</ng-template>
